export const loaderEnabledButtonClassName = "js-loader-enabled-button";
export const loaderEnabledButtonAlertContentClassName = "js-sr-alert-content";
export const loaderEnabledButtonAlertTranslationKey = "loading";
export const loaderEnabledButtonIdsToHideAttributeName =
  "data-hide-during-loading";

export function showButtonLoader(loadingText: string): void {
  setLoaderState({ loading: true, loadingText });
}

export function hideButtonLoader(): void {
  setLoaderState({ loading: false });
}

// A bfcache restore replays the preserved DOM (is-loading, aria-disabled,
// native disabled, alert text) without re-running module scripts, so a loader
// shown before a redirect would otherwise stay stuck. pageshow with persisted
// is the one signal for "restored without re-init".
export function initLoaderRestoreReset(): void {
  window.addEventListener("pageshow", (e) => {
    if ((e as PageTransitionEvent).persisted) {
      hideButtonLoader();
    }
  });
}

function setLoaderState(
  params: { loading: true; loadingText: string } | { loading: false },
): void {
  const buttons = document.getElementsByClassName(loaderEnabledButtonClassName);

  Array.from(buttons).forEach((button) => {
    if (params.loading) {
      button.classList.add("is-loading");
      button.setAttribute("aria-disabled", "true");
      // For native <button> elements, also toggle the `disabled` property so
      // keyboard activation (Enter/Space) is blocked while loading — aria-disabled
      // alone does not prevent it.
      if (button instanceof HTMLButtonElement) {
        button.dataset.loaderPrevDisabled = String(button.disabled);
        button.disabled = true;
      }
    } else {
      button.classList.remove("is-loading");
      button.removeAttribute("aria-disabled");
      // Only restore the native `disabled` state if this loader actually
      // captured it (i.e. showButtonLoader ran first). If hideButtonLoader is
      // called without a prior showButtonLoader, leave `disabled` untouched so
      // we never force-enable a button that was disabled for other reasons.
      if (
        button instanceof HTMLButtonElement &&
        button.dataset.loaderPrevDisabled !== undefined
      ) {
        button.disabled = button.dataset.loaderPrevDisabled === "true";
        delete button.dataset.loaderPrevDisabled;
      }
    }

    const alert = button.getElementsByClassName(
      loaderEnabledButtonAlertContentClassName,
    )[0];
    if (alert) {
      alert.textContent = params.loading ? params.loadingText : "";
    }

    const idsAttr = button.getAttribute(
      loaderEnabledButtonIdsToHideAttributeName,
    );
    if (!idsAttr) return;

    idsAttr
      .split(",")
      .map((id) => id.trim())
      .forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.style.visibility = params.loading ? "hidden" : "visible";
      });
  });
}
